<template>
    <div>
        <div class="banner-container">
            <img class="career-img" src="../../assets/image/career/career-banner.jpg" />
            <p class="join-title">Join Our Team</p>
        </div>
        <el-breadcrumb class="breadcrumb-container" separator="/">
            <el-breadcrumb-item class="breadcrumb-item" :to="{ path: '/career' }">Career</el-breadcrumb-item>
            <el-breadcrumb-item class="breadcrumb-item">Software Developer Intern</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="job-container">
            <p class="title">Software Developer Intern</p>
            <div class="description-container">
                <p class="subtitle">Job Requirements</p>
                <ul class="requirement-list">
                    <li class="list-details">Any University Students in the following field can apply:</li>
                    <li class="list-details"> Information Technology</li>
                    <li class="list-details"> Language: English or Chinese</li>
                </ul>
            </div>

            <div class="description-container">
                <p class="subtitle">Benefits of U-Pay Internship Program</p>
                <ul class="requirement-list">
                    <li class="list-details"> Monthly Allowance</li>
                    <li class="list-details"> Professional Work Environment</li>
                    <li class="list-details"> Cetificate of Internship</li>
                    <li class="list-details"> Assistance in Career Development</li>
                    <li class="list-details"> Letter of Recommendation</li>
                    <li class="list-details"> Possibly Become Full-time U-Pay Employee</li>
                </ul>
            </div>

            <div class="description-container">
                <p class="subtitle">Internship Obligations</p>
                <ul class="requirement-list">
                    <li class="list-details"> Monday Friday</li>
                    <li class="list-details"> Full Time (8:30am-12pm, 1:00pm-5:00pm)</li>
                    <li class="list-details"> 3 months</li>
                </ul>
            </div>

            <div class="description-container">
                <p class="subtitle">How to Apply</p>
                <p class="requirement-list">Interested candidates please submit your CV/resume with a photo and accompanied by cover letter and any other supporting documents to HR Department:</p>
                <div class="hr-contact">
                    <p class="hr-contact-details">Contact Person : HR Department</p>
                    <p class="hr-contact-details">Email: hr@u-pay.com</p>
                    <p class="hr-contact-details">Contact: 069 931 888 / 077 266 123 </p>
                    <p class="hr-contact-details">Website: www.u-pay.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.banner-container {
  position: relative;
  .career-img {
    width: 100%;
  }
  .join-title {
    color: white;
    position: absolute;
    bottom: 3%;
    left: 4%;
    font-size: 2.2rem;
    font-weight: bolder;
  }
}
.job-container {
    display: table;
    margin-right: auto;
    margin-left: auto;
    padding: 3% 35% 3% 35%;
    .title {
        color: #0277E3;
        text-align: center;
        font-size: 1.55rem;
        font-weight: bold;
    }
}

.description-container{
    padding-top: 8%;
    .subtitle {
        color: black;
        text-align: center;
        font-size: 1.35rem;
        font-weight: bold;
    }
    .requirement-list{
        margin: 3% 0% 5% 0%;

        .list-details {
            margin-bottom: 0.5%;
            display: list-item;
            list-style-type: disc;
        }
    }
    .salary{
        font-weight: bolder;
    }

    .hr-contact .hr-contact-details {
        margin-bottom: 3%;
        font-weight: bold;
    }
}

.breadcrumb-container {
    margin : 3% 3%;
}

.breadcrumb-item {
    color: darkgray;
    font-weight: 600;
    font-size: 1.0rem;
}

@media only screen and (max-width: 600px) {
    .job-container {
        display: table;
        margin-right: auto;
        margin-left: auto;
        padding: 3% 5% 3% 5%;
        .title {
            color: #0277E3;
            text-align: center;
            font-size: 1.10rem;
            font-weight: bold;
        }
    }
}
</style>

// <style lang="less" scoped>
// .banner-container {
//   position: relative;
//   .career-img {
//     width: 100%;
//   }
//   .join-title {
//     color: white;
//     position: absolute;
//     bottom: 3%;
//     left: 4%;
//     font-size: 2.2rem;
//     font-weight: bolder;
//   }
// }
// .job-container {
//     display: table;
//     margin-right: auto;
//     margin-left: auto;
//     padding: 3% 25% 3% 25%;
//     .title {
//         color: #0277E3;
//         text-align: center;
//         font-size: 1.55rem;
//         font-weight: bold;
//     }
// }

// .description-container{
//     padding-top: 5%;
//     .subtitle {
//         color: black;
//         text-align: center;
//         font-size: 1.35rem;
//         font-weight: bold;
//     }
//     .requirement-list{
//         margin: 3% 15% 5% 15%;

//         .list-details {
//             margin-bottom: 0.5%;
//             display: list-item;
//             list-style-type: disc;
//         }
//     }
//     .salary{
//         font-weight: bolder;
//     }

//     .hr-contact .hr-contact-details {
//         margin-bottom: 3%;
//         font-weight: bold;
//     }
// }
// .breadcrumb-container {
//     margin : 3% 3%;
// }

// .breadcrumb-item {
//     color: darkgray;
//     font-weight: 600;
//     font-size: 1.0rem;
// }
// </style>
